import { useTranslation } from 'react-i18next'

import { SectionHeader } from './SectionHeader'
import styles from './AboutPreview.module.scss'

/**
 * A link preview of the parent platform's own about page: its share image, its real headline. One
 * anchor, so the whole card is the link — no second click target to miss. Nothing is restated here
 * that the page does not say itself.
 */
export const AboutPreview = () => {
  const { t } = useTranslation()

  return (
    <section id="about" className={styles.root}>
      <SectionHeader kicker={t('landing.about.kicker')} title={t('landing.about.title')} />
      <a className={styles.card} href="https://intch.org/about-us" target="_blank" rel="noopener">
        <img src="/media/about-share.webp" alt="" decoding="async" width={900} height={473} />
        <div className={styles.body}>
          <span className={styles.url}>intch.org/about-us</span>
          <b>{t('landing.about.headline')}</b>
          <p>{t('landing.about.text')}</p>
          <span className={styles.go}>{t('landing.about.go')} →</span>
        </div>
      </a>
    </section>
  )
}
